<svelte:options customElement={{ tag: "bt-inline-pagination-page" }} />

<script lang="ts">
	import { onMount } from 'svelte';
	import { eventBus } from '$shared/lib/eventBus';

	export let index: string | number = 0;
	export let paginationId = '';

	let isActive = false;

	onMount(() => {
		// Converting index attr to number off the bat to prevent future tsoris
		index = +index;

		eventBus.emit('inline-pagination-page-ready', {
			pageIndex: index,
			paginationId: paginationId
		})

		return () => {
			eventBus.off('inline-pagination-change');
		}
	});

	eventBus.on('inline-pagination-change', (event) => {
		if (event.paginationId === paginationId) {
			isActive = event.targetPageIndex === index
		}
	});
</script>

<svelte:window />

<div class={`${isActive ? '' : 'hidden'}`}>
	<slot name="page"></slot>
</div>

<style>
	.hidden { display: none; }
</style>
